import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TOAST_STATE } from './toast-item';
import { ToastComponent } from './toast.component';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  standalone: true,
  imports: [ToastComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastContainerComponent {
  protected readonly state = inject(TOAST_STATE);
}
